import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const RegistrationContext = createContext();

const STORAGE_KEY = 'servicegest_registration_data';

export const RegistrationProvider = ({ children }) => {
  const [registrationData, setRegistrationDataState] = useState(() => {
    // Initialize from sessionStorage if available
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  // Persist to sessionStorage when data changes
  useEffect(() => {
    if (registrationData) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(registrationData));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [registrationData]);

  const setRegistrationData = useCallback((dataOrUpdater) => {
    if (typeof dataOrUpdater === 'function') {
      setRegistrationDataState(prev => dataOrUpdater(prev));
    } else {
      setRegistrationDataState(dataOrUpdater);
    }
  }, []);

  const clearRegistrationData = useCallback(() => {
    setRegistrationDataState(null);
    sessionStorage.removeItem(STORAGE_KEY);
  }, []);

  const hasRegistrationData = Boolean(
    registrationData?.shopId && 
    registrationData?.accountId
  );

  return (
    <RegistrationContext.Provider 
      value={{
        registrationData,
        setRegistrationData,
        clearRegistrationData,
        hasRegistrationData
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
};

export const useRegistration = () => {
  const context = useContext(RegistrationContext);
  if (!context) {
    throw new Error('useRegistration must be used within a RegistrationProvider');
  }
  return context;
};
